import React, { useState, useEffect } from 'react';
import { Container, Typography, IconButton } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import "./AddressDetail.css";
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import BoxDetail from './components/BoxDetail';
import alerta from "../../images/alerta.png";
import IconArrow from "../../images/ICON_ARROW.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import MessageAddress from './components/MessageAddress/MessageAddress';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useSection } from '../../context/SectionContext';
import { useDatosUser } from "../../context/userContext";
import { useNavigate } from "react-router-dom";
import useRedirectIframe from "../../hooks/useRedirectIframe";
import { URLS } from "../../context/urls";
import { ADDRESS_DETAIL_TEXTS } from './addressDetailTexts'; 

const AddressDetail = () => {
    const navigate = useNavigate();
    const { nombreCompleto, completed, wuujuID, phone } = useDatosUser();

useRedirectIframe(URLS.REDIRECT_IFRAME);

    useEffect(() => {
        if (completed === false || completed === null) {
            navigate('/crear-casillero-2');
        }
    }, [completed, navigate]); 

    const { optionalVariable, changeSection } = useSection();
    const options = [
        //Compras Apple BY:BETANCUR SAPATO
        {
            name: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.NAME,
            apellido: "WUUJU",
            text: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.TEXT,
            color: "#0a0a0a",
            pText: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.MESSAGE,
            messageHeight: "29vw",
            icon: <HomeIcon sx={{  fontSize: {xs: '4vw', sm: '2vw'}, marginLeft:"0.6vw" }} />,
            variable: {
                Direccion: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.ADDRESS.DIRECCION,
                Apto: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.ADDRESS.APTO,
                Estado: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.ADDRESS.ESTADO,
                Ciudad: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.ADDRESS.CIUDAD,
                CodigoPostal: ADDRESS_DETAIL_TEXTS.OPTIONS.APPLE.ADDRESS.CODIGO_POSTAL,
            }},
         //Compras Menores a 200 USD Express BY:BETANCUR SAPATO
         {
            name: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.NAME,
            apellido:`${wuujuID} EX`,
            text: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.TEXT,
            color: "#b3df53",
            pText: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.MESSAGE,
            messageHeight: "23vw",
            icon: <ShoppingCartOutlinedIcon sx={{  fontSize: {xs: '5vw', sm: '2vw'}, marginLeft:{xs: '1vw', sm: '0.6vw'} }} />,
            variable: {
                Direccion: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.ADDRESS.DIRECCION,
                Estado: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.ADDRESS.ESTADO,
                Ciudad: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.ADDRESS.CIUDAD,
                CodigoPostal: ADDRESS_DETAIL_TEXTS.OPTIONS.EXPRESS.ADDRESS.CODIGO_POSTAL,
            }},
        //Compras Mayores a 200 USD BY:BETANCUR SAPATO
        {
            name: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.NAME,
            apellido: `${wuujuID} 8006465`,
            text: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.TEXT,
            color: "#FB8065",
            pText: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.MESSAGE,
            messageHeight: "18vw",
            icon: <ShoppingCartOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '2vw' }, marginLeft: "0.6vw" }} />,
            variable: {
                Direccion: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.ADDRESS.DIRECCION,
                Apto: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.ADDRESS.APTO,
                Estado: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.ADDRESS.ESTADO,
                Ciudad: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.ADDRESS.CIUDAD,
                CodigoPostal: ADDRESS_DETAIL_TEXTS.OPTIONS.MAJOR.ADDRESS.CODIGO_POSTAL,
            }
        },
        {
            name: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.NAME,
            apellido: `NY-${wuujuID}`,
            text: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.TEXT,
            color: "#009ad5",
            pText: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.MESSAGE,
            messageHeight: "15vw",
            icon: <ShoppingCartOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '2vw' }, marginLeft: "0.6vw" }} />,
            variable: {
                Direccion: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.ADDRESS.DIRECCION,
                Apto: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.ADDRESS.APTO,
                Estado: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.ADDRESS.ESTADO,
                Ciudad: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.ADDRESS.CIUDAD,
                CodigoPostal: ADDRESS_DETAIL_TEXTS.OPTIONS.MINOR.ADDRESS.CODIGO_POSTAL,
            }
        },
    ];

    const findIndexByName = (name) => {
        return options.findIndex(item => item.name === name);
    };

    const [selectedOptionIndex, setSelectedOptionIndex] = useState(findIndexByName(optionalVariable));

    const handleNextClick = () => {
        setSelectedOptionIndex((prevIndex) => (prevIndex + 1) % options.length);
    };

    const handlePrevClick = () => {
        setSelectedOptionIndex((prevIndex) => (prevIndex - 1 + options.length) % options.length);
    };

    return (
        <>
            <IconButton
                aria-label="close"
                onClick={() => changeSection('direcciones')}
                style={{ position: 'absolute', left: '1vw', top: '0.2vw' }}
            >
                <ArrowBackIcon sx={{
                    color: "#5452ff",
                    fontSize: { xs: '5vw', sm: '1vw', md: '1vw', lg: '1.5vw', xl: '2vw' },
                    p: "1px",
                }} /> <span className='boton-regresar' style={{ paddingLeft: '0.5vw', fontFamily: 'Viga' }}>Regresar</span>
            </IconButton>
            <Container maxWidth="xl" className='address-main' sx={{ paddingTop: "2vw" }}>
                <h1 className='title-direccion'>{ADDRESS_DETAIL_TEXTS.MAIN_TITLE} <span className="break-title"></span></h1>
                <div className='compra-variable-container'>
                    <img
                        src={IconArrow}
                        alt="Anterior"
                        onClick={handlePrevClick}
                        className='custom-button1'
                    />
                    <div className='compra-variable' style={{ backgroundColor: options[selectedOptionIndex].color }}>
                        {options[selectedOptionIndex].icon}
                        <span>{options[selectedOptionIndex].text}</span>
                    </div>
                    <img
                        src={IconArrow}
                        alt="Siguiente"
                        onClick={handleNextClick}
                        className='custom-button2'
                    />
                </div>

                <p className='general-text'> <img src={alerta} alt="" className='img-alert2' /> {ADDRESS_DETAIL_TEXTS.TERMS_CONDITIONS_TEXT}
                    <a href={URLS.VIRTUAL_LOCKER_INSTRUCTIONS} rel="noreferrer" target="_blank" className='terminos-text'>{ADDRESS_DETAIL_TEXTS.TERMS_CONDITIONS_TEXT2} </a></p>

                <BoxDetail
                    label="Nombre"
                    variable={nombreCompleto}
                    icon={<PermIdentityOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                <BoxDetail
                    label="Apellido"
                    variable={options[selectedOptionIndex].apellido}
                    icon={<PermIdentityOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                <BoxDetail
                    label="Dirección"
                    variable={options[selectedOptionIndex]?.variable.Direccion}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                {options[selectedOptionIndex]?.variable.Apto && (
                    <BoxDetail
                        label="Apto"
                        variable={options[selectedOptionIndex].variable.Apto}
                        icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                        color={options[selectedOptionIndex].color}
                    />
                )}
                <BoxDetail
                    label="Estado"
                    variable={options[selectedOptionIndex]?.variable.Estado}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                <BoxDetail
                    label="Ciudad"
                    variable={options[selectedOptionIndex]?.variable.Ciudad}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                <BoxDetail
                    label={<>Código <br /> Postal</>}
                    variable={options[selectedOptionIndex]?.variable.CodigoPostal}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                <BoxDetail
                    label="Teléfono"
                    variable={phone}
                    icon={<PhoneOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={options[selectedOptionIndex].color}
                />
                <MessageAddress
                    text={options[selectedOptionIndex]?.pText}
                    height={options[selectedOptionIndex]?.messageHeight}
                />
                <div className='typography-content-1'>
                    <Typography
                        sx={{
                            color: 'gray',
                            fontFamily: 'Viga, sans-serif',
                            fontSize: { xs: '3vw', sm: '1vw' },
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        {ADDRESS_DETAIL_TEXTS.DOUBTS_TEXT}
                        <span className='whatsapp-icon-container-1'>
                            <WhatsAppIcon className="whatsapp-icon-1"
                                sx={{
                                    color: "#5452ff",
                                    fontSize: { xs: '3vw', sm: '0.9vw' }
                                }} />
                        </span>
                        <a
                            href={URLS.CONTACT_US}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link-1"
                        >
                            {ADDRESS_DETAIL_TEXTS.CONTACT_US_TEXT}
                        </a>
                        ───
                    </Typography>
                </div>
            </Container>
        </>
    );
}

export default AddressDetail;
